import { ApolloClient, InMemoryCache } from '@apollo/client';
import { ONCHAIN_SERVER } from 'utils/constants/common';

export const ONCHAIN_SERVER_BASE_URL = ONCHAIN_SERVER;

const ONCHAIN_SERVER_GRAPHQL_URL = ONCHAIN_SERVER + `/graphql`;

export const ONCHAIN_APOLLO_CLIENT = new ApolloClient({
  uri: ONCHAIN_SERVER_GRAPHQL_URL,
  cache: new InMemoryCache(),
});
